import React, { useEffect, useState } from 'react'

const Filter = ({ contributor, onChangeFilter, statusCount }) => {

    console.log(statusCount)
    const [state, setState] = useState({
        contributor: { name: 'contributor', value: '' },
        favourite: { name: 'favourite', value: false },
        hasMyComment: { name: 'hasMyComment', value: false },
        hasAttachment: { name: 'hasAttachment', value: false },

    })



    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: value
            }
        }));
    };


    useEffect(() => {
        const model = {
            favourite: state.favourite.value,
            hasMyComment: state.hasMyComment.value,
            contributor: state.contributor.value,
            hasAttachment: state.hasAttachment.value,
        }
        onChangeFilter(model)
    }, [state])
    return (
        <div className="plan-approval-index-top filters-card-top">
            <div className="filters-card">
                <h5 className="filters-title">Filters</h5>
                <div className="filter-tab-channels-box ncrfilter filter-top-box">
                    <div className="input-box">
                        <select className="form-select"
                            name={state.contributor.name}
                            value={state.contributor.value}
                            onChange={handleChange}
                        >
                            <option>Select Contributor </option>
                            {contributor?.map((item) => {
                                return (
                                    <option value={item.user_id}>{item.full_name} </option>
                                )
                            })}
                        </select>
                    </div>
                    <div
                        className={state.favourite.value ? 'input-box active' : 'input-box'}
                    >
                        <button type="button"
                            onClick={() =>
                                handleChange({
                                    target: {
                                        name: 'favourite',
                                        value: !state.favourite.value,
                                    },
                                })
                            }

                        >
                            <i className="bx bx-star" /> Favourites
                        </button>
                    </div>
                    {/* <div className="input-box">
                        <button type="button">
                            <i className="fa fa-reply" /> Reply Owed
                        </button>
                    </div> */}
                    {/* <div className="input-box">
                        <button type="button">
                            <i className="fa fa-reply-all" /> Reply Owed Third Party-
                            Urgent
                        </button>
                    </div> */}
                    {/* <div className="input-box">
                        <button type="button">
                            <i className="fa fa-reply-all" /> Reply Owed Third Party
                        </button>
                    </div> */}
                    <div
                        className={state.hasMyComment.value ? 'input-box active' : 'input-box'}

                    >
                        <button
                            type="button"
                            onClick={() =>
                                handleChange({
                                    target: {
                                        name: 'hasMyComment',
                                        value: !state.hasMyComment.value,
                                    },
                                })
                            }
                        >
                            Has My Comments
                        </button>
                    </div>
                    {/* <div className="input-box">
                        <button type="button">
                            <i className="fa fa-bolt" /> Has Follow Up
                        </button>
                    </div> */}
                    <div
                        className={state.hasAttachment.value ? 'input-box active' : 'input-box'}

                    >
                        <button
                            type="button"
                            onClick={() =>
                                handleChange({
                                    target: {
                                        name: 'hasAttachment',
                                        value: !state.hasAttachment.value,
                                    },
                                })
                            }
                        >
                            <i className="fa fa-paperclip" />  Has Attachments
                        </button>
                    </div>

                </div>
            </div>
            <div className="counter-box-right">
                <h5 className="box-title">Comments Status</h5>
                <div className="count-box">
                    <h6>
                        Draft <span>{statusCount?.Draft}</span>
                    </h6>
                </div>
                <div className="count-box">
                    <h6>
                        Archived <span>{statusCount?.Archived}</span>
                    </h6>
                </div>
                <div className="count-box">
                    <h6>
                        Open <span>{statusCount?.Opened}</span>
                    </h6>
                </div>
                <div className="count-box">
                    <h6>
                        Accepted <span>{statusCount?.Accepted}</span>
                    </h6>
                </div>
                {/* <div className="count-box">
                    <h6>
                        Cancelled <span>2</span>
                    </h6>
                </div> */}
            </div>
        </div>
    )
}

export default Filter